import { useLogger } from '@/utils/logger';
import { ref } from 'vue';

export const useViewDepthLog = () => {
    const { logger } = useLogger();
    const deepestIdx = ref(0);

    const updateViewDepthParams = (idx: number) => {
        const newIdx = idx + 1;
        if (newIdx > deepestIdx.value) {
            deepestIdx.value = newIdx;
            logger?.updateCurrentUrlPackage({
                params: {
                    view_depth: deepestIdx.value,
                },
            });
        }
    };

    return {
        updateViewDepthParams,
    };
};
